module.exports = __webpack_public_path__ + "themes/mf/img/character.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/character.png
// module id = 71
// module chunks = 3